import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearBusBodyWorks,
  getBusesBodyWorks,
} from '../../../../actions/bus/BusBodyWork';
import { DEFAULT_QUERY } from '../../../../config/queries';

export const BusBodyWorkSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearBusesBodyWorks,
  dispatchGetBusesBodyWorks,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearBusesBodyWorks(), []);

  const handleInputChange = (inputValue) => {
    if (inputValue.trim().length && inputValue.trim().length >= 4) {
      dispatchGetBusesBodyWorks({
        ...DEFAULT_QUERY,
        query: inputValue,
      });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={handleInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

BusBodyWorkSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetBusesBodyWorks: PropTypes.func.isRequired,
  dispatchClearBusesBodyWorks: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

BusBodyWorkSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca así: código,nombre',
};

const mapStateToProps = ({ BusUnit }) => ({
  options: BusUnit.BusBodyWork.getIn(['all', 'content', 'content']).map(
    ({ id, make, model, year }) => ({
      value: id,
      label: `${make} | ${model} | ${year}`,
    }),
  ),
  loading: BusUnit.BusBodyWork.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetBusesBodyWorks: getBusesBodyWorks,
  dispatchClearBusesBodyWorks: clearBusBodyWorks,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusBodyWorkSelect);
